import { n as e } from "../chunks/index.es.CfT5btWg.js";
import { Heading1Icon as t, Heading2Icon as n, ListStartIcon as r, MapIcon as i, TextIcon as a } from "lucide-react";
import { jsx as o } from "react/jsx-runtime";
//#region lib/Text/textStyles.tsx
var s = (e) => [
	{
		name: "set-heading-1",
		role: "heading-1",
		title: `${e?.titleLabel}` || "Title",
		hotkey: (e?.preventHotkeys)?.includes("heading-1") ? void 0 : "mod+option+1",
		tool: () => /* @__PURE__ */ o(t, { style: {
			width: "1em",
			height: "1em"
		} }),
		handler: ({ editor: e }) => {
			l(e, "heading-1");
		},
		visibility: (e) => c(e, "heading-1")
	},
	{
		name: "set-heading-2",
		role: "heading-2",
		title: `${e?.subTitleLabel}` || "Subtitle",
		hotkey: (e?.preventHotkeys)?.includes("heading-2") ? void 0 : "mod+option+2",
		tool: () => /* @__PURE__ */ o(n, { style: {
			width: "1em",
			height: "1em"
		} }),
		handler: ({ editor: e }) => l(e, "heading-2"),
		visibility: (e) => c(e, "heading-2")
	},
	{
		name: "set-preamble",
		role: "preamble",
		title: `${e?.preambleLabel}` || "Preamble",
		hotkey: (e?.preventHotkeys)?.includes("preamble") ? void 0 : "mod+option+3",
		tool: () => /* @__PURE__ */ o(r, { style: {
			width: "1em",
			height: "1em"
		} }),
		handler: ({ editor: e }) => l(e, "preamble"),
		visibility: (e) => c(e, "preamble")
	},
	{
		name: "set-body",
		title: `${e?.bodyTextLabel}` || "Body text",
		hotkey: "mod+option+0",
		tool: () => /* @__PURE__ */ o(a, { style: {
			width: "1em",
			height: "1em"
		} }),
		handler: ({ editor: e }) => l(e),
		visibility: (e) => c(e)
	},
	{
		name: "set-dateline",
		role: "vignette",
		title: `${e?.vignetteLabel}` || "Vignette",
		hotkey: void 0,
		tool: () => /* @__PURE__ */ o(i, { style: {
			width: "1em",
			height: "1em"
		} }),
		handler: ({ editor: e }) => l(e, "vignette"),
		visibility: (e) => c(e, "vignette")
	}
].filter((t) => !(t.role && Array.isArray(e.hiddenStyles) && e.hiddenStyles.includes(t.role) || t.role && Array.isArray(e.styles) && !e.styles.includes(t.role)));
function c(e, t) {
	return [
		[
			"core/ordered-list",
			"core/unordered-list",
			"core/text"
		].includes(e.type),
		!0,
		e.type === "core/text" && e?.properties?.role === t
	];
}
function l(t, n) {
	e.convertToTextNode(t, "core/text", n);
}
//#endregion
export { s as getTextStyles };
